<template>
  <div v-if="show">
    <van-popup
      ref="previewFile"
      v-model="show"
      fullscreen
      width="100%"
      style="margin-top: 0; width: 100%; height: 100vh; overflow: hidden;"
      class="no-scroll"
    >
      <div class="preview-body">
        <div class="header">
          <div class="fileName">
            {{ fileName }}
          </div>
          <div class="opt-bar">
            <!-- <svg-icon
              icon-class="copy-url"
              class-name="downloadButton copy"
              @click="copy(oldUrl)"
            /> -->
            <svg-icon
              v-if="!blobType"
              icon-class="download"
              class-name="downloadButton"
              @click="download(oldUrl)"
            />
            <svg-icon
              icon-class="close"
              class-name="closeButton"
              @click="onClose"
            />
          </div>
        </div>
        <iframe
          :src="blobType ? oldUrl : url"
          :height="dialogHeight"
          frameborder="0"
          width="100%"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getFileNameFromUrl } from '@/utils/utils'

export default {
  name: 'PreviewFile',
  props: {
    callback: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      show: false,
      url: '',
      dialogHeight: 800,
      fileName: '',
      blobType: null,
      image: false,
      oldUrl: ''
    }
  },
  computed: {
    fileType() {
      return this.oldUrl.split('.').pop()
    }
  },
  methods: {
    copy(url) {
      this.$copyText(url).then(
        () => {
          this.$message.success('复制成功')
        },
        () => {
          this.$message.error('复制失败')
        }
      )
    },
    open(url, blobType, fileName) {
      this.blobType = blobType
      // 判断一下 url 是否属于 json 串
      if (typeof url === 'string') {
        try {
          url = JSON.parse(url)
          url = url[0].url
        } catch (error) {
          console.log(error)
        }
      }
      this.fileName = fileName || getFileNameFromUrl(url)
      this.image = this.isPic(url)
      this.show = true
      this.oldUrl = url
      this.url = 'https://filekk.newhopehg.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)) + '&officePreviewType=' + this.fileType
      this.$nextTick(() => {
        this.dialogHeight = document.body.clientHeight - 20
        // document.querySelector('.el-dialog').style.height = '100%'
      })
    },
    onClose() {
      console.log('close', this.$refs.previewFile)

      this.show = false
      this.image = false
      this.$nextTick(() => {
        document.querySelector('.el-dialog').style.height = ''
      })
      this.callback && this.callback()
    },
    download(url) {
      if (!url.startsWith('http')) {
        this.$message.error('文件地址不合法~')
        return
      }
      try {
        // 解析地址中文件名
        const fileName = decodeURIComponent(url.split('/').pop())
        const link = document.createElement('a') // 创建a标签
        link.download = fileName // a标签添加属性
        link.style.display = 'none'
        link.target = '_blank'
        link.href = url
        document.body.appendChild(link)
        link.click() // 执行下载
        URL.revokeObjectURL(link.href) // 释放url
        document.body.removeChild(link) // 释放标签
      } catch (error) {
        this.$message.error('文件下载失败')
      }
    },

    isPic(url) {
      //   检测 url 是否为图片类型
      return /\.(jpg|jpeg|png|gif|bmp|tiff|webp|svg)$/.test(url)
    }
  }
}
</script>

<style lang="scss" scoped>
#fileViewer .el-dialog {
  /* Custom styles to ensure it doesn't affect other dialogs */
  width: 100vw; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  margin: 0; /* Remove default margins */
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog {
  background: transparent;
}
::v-deep .el-dialog__header {
  display: none;
}
.closeButton {
  width: 30px;
  height: 30px;
}
.preview-body {
  background: #404040;
  padding: 40px 10px 0 10px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  .content {
    background: #424246;
  }
  // overflow: hidden;
  .header {
    position: fixed;
    top: 0;
    width: 100%;
    background: #404040;
    height: 40px;
    line-height: 40px;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 9999;
    .opt-bar {
      display: flex;
      align-items: center;
    }
    .fileName {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .downloadButton,
  .closeButton {
    width: 30px;
    height: 30px;
    transform: scale(1);
    transition: all 0.3s;
    margin-left: 10px;
    &:hover {
      cursor: pointer;
      transform: scale(1.2);
      transition: all 0.3s;
    }
  }
  .copy {
    width: 18px;
    height: 18px;
  }
}
.no-scroll .el-dialog__body {
  // overflow: hidden; /* 隐藏对话框内的滚动条 */
}
</style>
